<template>
  <div>
    <h3 style="position:absolute;top:2px;right:2px">Admin</h3>
    <tabbed-panel tabstr="Submissions,Settings" v-if="controlrecord&&controlrecord.code==1">
        <submissionsTable v-if="isOk" :subs="subs" slot="Submissions"/>
        <adminForm v-if="isOk" :controlrecord="controlrecord" slot="Settings" />
    </tabbed-panel>
    <spinner v-else />
  </div>
</template>

<script>
import tabbedPanel from '@/components/tabbed-panel.vue'
import adminForm from '@/components/admin-form.vue'
import submissionsTable from '@/components/submissions-table.vue'
import spinner from '@/components/spinner.vue'

export default {
  name: 'Admin',
  components: {tabbedPanel, adminForm, submissionsTable, spinner},
  data () {
    return {
      controlrecord: Object,
      subs:[],
      loginWindow: undefined,
      isOk: false,
      notAuth: false
    }
  },
  mounted: async function () {
    try {
        const response = await fetch(process.env.VUE_APP_ENDP1, {mode:"cors", credentials:"same-origin"});
        const json = await(response.json());
        this.controlrecord = json.control;
        this.subs = json.subs;
        this.isOk = true;
    } catch (ex){
        // wait a few seconds then redirect to a login stub behind the SSO
        window.setTimeout(function() {
            // window.open("/ssostaff/qmail/CloseAfterAuth.html?s=/fracp/","_self");
            alert(`Unable to authenticate: ${ex}`);
        }, 1600);
    }
  }
}
</script>
